import { type LoginRequest, MeResponse } from '@serievo/contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost, apiPostVoid, devToken } from './client';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: ({ signal }) => apiGet('/auth/me', MeResponse, { signal }),
    select: (r) => r.data,
    staleTime: 60_000,
    retry: false,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: LoginRequest) => apiPost('/auth/login', body, MeResponse),
    onSuccess: (r) => {
      // Bỏ dữ liệu của phiên trước, giữ query me đang được theo dõi rồi đặt kết quả mới.
      qc.removeQueries({ predicate: (q) => q.queryKey[0] !== 'me' });
      qc.setQueryData(['me'], r);
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      devToken.set(null);
      await apiPostVoid('/auth/logout', {});
    },
    onSettled: () => {
      qc.removeQueries({ predicate: (q) => q.queryKey[0] !== 'me' });
      void qc.refetchQueries({ queryKey: ['me'] });
    },
  });
}
